/**
 * 根据域名返回相关的字段，用于区分不同域名下的不同业务
 */

/**
 *
 * @returns {string} 根据域名返回不同baseURL
 */
export function getGlobalName() {
  let globalName = "龙艺秀";
  switch (window.location.hostname) {
    case "www.longyixiu.com":
    case "longyixiu.com":
      globalName = "龙艺秀";
      break;
    case "www.wenjuanjia.com":
    case "wenjuanjia.com":
    case "192.168.1.138":
      globalName = "问卷家";
      break;
    default:
      globalName = "龙艺秀";
      break;
  }
  return globalName;
}
/**
 *
 * @returns {string} 根据域名返回不同subName
 */
export function getSubName() {
  let subName: any = "longyixiu";
  switch (window.location.hostname) {
    case "www.longyixiu.com":
    case "longyixiu.com":
      subName = "longyixiu";
      break;
    case "www.wenjuanjia.com":
    case "wenjuanjia.com":
      subName = "wenjuanjia";
      break;
    default:
      subName = "longyixiu";
      break;
  }
  return subName;
}
/**
 *
 * @returns {string} 根据域名返回不同baseURL
 */
export function getBaseUrl() {
  let baseURL = process.env.VUE_APP_BASE_API;
  switch (window.location.hostname) {
    case "www.longyixiu.com":
    case "longyixiu.com":
      baseURL = process.env.VUE_APP_BASE_API;
      break;
    case "www.wenjuanjia.com":
    case "wenjuanjia.com":
    case "192.168.1.138":
      baseURL = process.env.VUE_APP_BASE_API2;
      break;
    default:
      baseURL = process.env.VUE_APP_BASE_API;
      break;
  }
  return baseURL;
}

/**
 *
 * @returns {string} 根据域名返回不同反馈页面
 */
export function getFeedbackUrl() {
  let url =
    `${process.env.VUE_APP_PREVIEW_URL}` +
    "/?questionId=FnMQYjGt8geUkFehIJTl1A%3D%3D";
  switch (window.location.hostname) {
    case "www.longyixiu.com":
    case "longyixiu.com":
      url =
        `${process.env.VUE_APP_PREVIEW_URL}` +
        "/?questionId=FnMQYjGt8geUkFehIJTl1A%3D%3D";
      break;
    case "www.wenjuanjia.com":
    case "wenjuanjia.com":
    case "192.168.1.138":
      url =
        "https://wj.wenjuanjia.com/?questionId=aXEietY1ICqFOZtOjJS1hg%3D%3D";
      break;
    default:
      url =
        `${process.env.VUE_APP_PREVIEW_URL}` +
        "/?questionId=FnMQYjGt8geUkFehIJTl1A%3D%3D";
      break;
  }
  return url;
}

/**
 *
 * @returns {string} 根据域名返回不同后台功能反馈页面
 */
export function getFeedbackUrl2() {
  let url =
    `${process.env.VUE_APP_PREVIEW_URL}` +
    "?questionId=clp4GjoOPyMolWYLibe3QQ%3D%3D";
  switch (window.location.hostname) {
    case "www.longyixiu.com":
    case "longyixiu.com":
      url =
        `${process.env.VUE_APP_PREVIEW_URL}` +
        "?questionId=clp4GjoOPyMolWYLibe3QQ%3D%3D";
      break;
    case "www.wenjuanjia.com":
    case "wenjuanjia.com":
    case "192.168.1.138":
      url =
        "https://wj.wenjuanjia.com/?questionId=wvLQdnnEskw5lhVp3rH1UQ%3D%3D";
      break;
    default:
      url =
        `${process.env.VUE_APP_PREVIEW_URL}` +
        "?questionId=clp4GjoOPyMolWYLibe3QQ%3D%3D";
      break;
  }
  return url;
}

/**
 *
 * @returns {string} 根据域名返回不同代理页面
 */
export function getAgencyUrl() {
  let url =
    "https://bd.longyixiu.net/?questionId=vC8w3C0vmE5f5le08Fo4Aw%3D%3D#";
  switch (window.location.hostname) {
    case "www.longyixiu.com":
    case "longyixiu.com":
      url =
        "https://bd.longyixiu.net/?questionId=vC8w3C0vmE5f5le08Fo4Aw%3D%3D#";
      break;
    case "www.wenjuanjia.com":
    case "wenjuanjia.com":
    case "192.168.1.138":
      url =
        "https://wj.wenjuanjia.com/?questionId=Hbq5AiYthVWlHUkC%2BOiGtw%3D%3D#";
      break;
    default:
      url =
        "https://bd.longyixiu.net/?questionId=vC8w3C0vmE5f5le08Fo4Aw%3D%3D#";
      break;
  }
  return url;
}

/**
 *
 * @returns {string} 根据域名返回不同帮助页面
 */
export function getHelpUrl() {
  let url =
    `${process.env.VUE_APP_PREVIEW_URL}` +
    "/?questionId=Q4CP7b8wgEUpYaJjIqK3Zw%3D%3D";
  switch (window.location.hostname) {
    case "www.longyixiu.com":
      url =
        `${process.env.VUE_APP_PREVIEW_URL}` +
        "/?questionId=Q4CP7b8wgEUpYaJjIqK3Zw%3D%3D";
      break;
    case "www.wenjuanjia.com":
    case "192.168.1.138":
      url =
        "https://wj.wenjuanjia.com/?questionId=Q4CP7b8wgEUpYaJjIqK3Zw%3D%3D";
      break;
    default:
      url =
        `${process.env.VUE_APP_PREVIEW_URL}` +
        "/?questionId=Q4CP7b8wgEUpYaJjIqK3Zw%3D%3D";
      break;
  }
  return url;
}

/**
 *
 * @returns {string} 根据域名返回不同代理页面
 */
export function getCancelUrl() {
  let url =
    `${process.env.VUE_APP_PREVIEW_URL}` +
    "/?questionId=VTReCKNx1NWBtRDGGaixpQ%3D%3D";
  switch (window.location.hostname) {
    case "www.longyixiu.com":
    case "longyixiu.com":
      url =
        `${process.env.VUE_APP_PREVIEW_URL}` +
        "/?questionId=VTReCKNx1NWBtRDGGaixpQ%3D%3D";
      break;
    case "www.wenjuanjia.com":
    case "wenjuanjia.com":
    case "192.168.1.138":
      url =
        "https://wj.wenjuanjia.com/?questionId=VTReCKNx1NWBtRDGGaixpQ%3D%3D";
      break;
    default:
      url =
        `${process.env.VUE_APP_PREVIEW_URL}` +
        "/?questionId=VTReCKNx1NWBtRDGGaixpQ%3D%3D";
      break;
  }
  return url;
}

/**
 *
 * @returns {string} 根据域名返回不同的来源编号
 */
export function getAppletSource() {
  let appletSource = 1;
  switch (window.location.hostname) {
    case "www.longyixiu.com":
    case "longyixiu.com":
      appletSource = 1;
      break;
    case "www.wenjuanjia.com":
    case "wenjuanjia.com":
    case "192.168.1.138":
      appletSource = 7;
      break;
    default:
      appletSource = 1;
      break;
  }
  return appletSource;
}
